import { Button, Grid, Paper } from "@mui/material";
import useReactHookForm from "hooks/useReactHookForm";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { getCollegeListData } from "utils/metadata-split/metaDataApiFetch";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import {
  areAllFieldsFilled,
  createStateLanguagePreInitialValues,
  createStateLanguagePreValidationSchema,
  createStateLanguageProperties,
} from "../helper";
import {
  getMainPageStatelanguagePrefListRequest,
  getStatelanguagePrefListRequest,
} from "pages/configue/slices/language-preferance-slice";
import { isEmpty } from "utils/helpers";

export const StateLanguagePreferanceFilter = ({ setShowSecondSec }) => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    createStateLanguagePreInitialValues,
    createStateLanguagePreValidationSchema,
    ""
  );
  const dispatch = useAppDispatch();
  const [triggerSetValue, setTriggerSetValue] = useState(false);
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const { updateFilterData, loading }: any = useAppSelector(
    (state) => state.languagePreferanceSlice
  );

  const clearFilter = () => {
    setValue("state_id", "");
    setValue("board_id", "");
    setValue("segment_id", "");
    setValue("class_id", "");
    setShowSecondSec(false);
  };

  const handleSearch = () => {
    setShowSecondSec(true);
    const reqBody = {
      state_id: watch().state_id,
      board_id: watch().board_id,
      segment_id: watch().segment_id,
      class_id: watch().class_id,
    };
    dispatch(getMainPageStatelanguagePrefListRequest(reqBody));
  };

  useEffect(() => {
    if (!isEmpty(updateFilterData)) {
      setValue("state_id", updateFilterData?.state_id);
      setValue("board_id", updateFilterData?.board_id);
      setValue("segment_id", updateFilterData?.segment_id);
      setValue("class_id", updateFilterData?.class_id);

      setShowSecondSec(true);
     const reqBody = {
      state_id: updateFilterData?.state_id,
      board_id: updateFilterData?.board_id,
      segment_id: updateFilterData?.segment_id,
      class_id: updateFilterData?.class_id,
    };
    dispatch(getMainPageStatelanguagePrefListRequest(reqBody));
    }
  }, [updateFilterData]);

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 2, marginTop: "10px" }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={createStateLanguageProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -1 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!areAllFieldsFilled([watch()])}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              // disabled={hasLengthGreaterThanZero(watch(), "boolean_operation")}
              disabled={!areAllFieldsFilled([watch()])}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
